/**
 * Componente especifico generador a partride de ADF 5.0.0.
 */

import { SearchQueryBuilderService, SearchWidget } from '@alfresco/adf-content-services';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomDataColumn, CustomSearchWidgetSettings } from 'projects/alden-extension/src/lib/models/custom-viewer-config';
import { executeFunction } from 'projects/alden-extension/src/lib/utils/dynamic-functions';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'smt-search-text-multi-property',
    templateUrl: './search-text-multi-property.component.html',
    styleUrls: ['./search-text-multi-property.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'smt-search-text-multi-property' }
})
export class SMTSearchTextMultiPropertyComponent implements SearchWidget, OnInit {

    /** The content of the text box. */
    value = '';

    id: string;
    settings: CustomSearchWidgetSettings;
    filter: CustomDataColumn;
    context: SearchQueryBuilderService;
    startValue: string;
    operator: string = 'OR';
    displayValue$: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

    //Custom SMT
    query: string;
    editable: boolean;

    constructor() {
        this.editable = true;
    }

    ngOnInit() {
        if(this.settings && this.settings.allowUpdateOnChange !== undefined && this.settings.allowUpdateOnChange !== null) {
            this.editable = this.settings.allowUpdateOnChange;
        }

        this.operator = this.settings?.operator ?? this.operator;
        if (this.context && this.settings && this.settings.pattern) {
            const pattern = new RegExp(this.settings.pattern, 'g');
            const match = pattern.exec(this.context.queryFragments[this.id] || '');

            if (match && match.length > 1) {
                this.value = match[1];
            }

            if (this.startValue) {
                this.setValue(this.startValue);
            }
        }
    }

    hasValidValue() {
        return !!this.value;
    }

    getCurrentValue() {
        return this.value;
    }

    submitValues() {
        this.updateQuery();
        this.updateDisplayValue();
    }

    reset() {
        this.value = '';
        this.updateQuery();
        this.updateDisplayValue();
    }

    updateDisplayValue(): void {
        if (!this.value) {
            this.displayValue$.next(null);
        } else {
            const maxLength = 25;
            const value = this.value;
            this.displayValue$.next({
                    value: value.substring(0, maxLength) + (value.length > maxLength ? '...' : ''),
                    tooltip: value
            });
        }
    }

    updateQuery() {
        if (this.context) {
            this.query = '';
            if(this.value){
                //Recorrer y añadir a query
                let fieldsArray: string[] = this.field ? [`@${this.field}:*${this.customData}=${this.searchPrefix}${this.formatValue(this.value)}${this.searchSuffix};`] : [];
                this.query = fieldsArray.length > 0 ? '('+fieldsArray.join(` ${this.operator} `)+')' : '';
            }
            this.context.queryFragments[this.id] = this.query;
            this.context.update();
        }
    }

    private formatValue(value: string): string {
        const formatFunction = this.settings.formatFunction;
        if (formatFunction) {
            return executeFunction(formatFunction, value);
        } else {
            return value;
        }
    }

    //Custom SMT
    getCurrentQuery() {
        return this.query;
    }

    setValue(value: string) {
        this.value = value;
    }

    getAppliedValue(): any {
        return this.value;
    }

    get searchPrefix(): string {
        return this.settings?.searchPrefix ?? '';
    }

    get searchSuffix(): string {
        return this.settings?.searchSuffix ?? '';
    }

    get customData(): any {
        return this.filter?.customData ?? null;
    }

    get field() : string {
        const settings = this.filter?.search.settings;
        if(settings) {
            const field = settings.field;
            if(field)
                return field;
        } else {
            const key = this.filter?.key.split('properties.');
            if(key?.length === 2)
                return key[1];
        }
        return "";
    }

    disable() {
        this.editable = false;
    }

    enable() {
        this.editable = true;
    }

}